<template>
    <div class="blank-layout">
        <slot />
    </div>
</template>

<script setup lang="ts">
// 空白布局，用于登录、注册等不需要底部导航的页面
</script>

<style lang="less" scoped>
.blank-layout {
    min-height: 100vh;
}
</style>
